import Axios from "axios";
import { decodeMessage, messageTypeHeaders } from "./HeadersMethods";
import Alerts from "./Alerts";
import { createRoot } from "react-dom/client";
import { showLoading, hideLoading } from "./loadingManager";
import { clearSessionData, getLoginUrl } from "./sessionManager";

Axios.defaults.withCredentials = true;

/** Login / recuperación de contraseña: el 401 es credencial inválida, no sesión expirada. */
const isAuthenticationRequest = (requestConfig) => {
  const url = String(requestConfig?.url ?? "");
  return /\/User\/login\b/i.test(url) || /\/User\/forgot/i.test(url);
};

const showAlert = (error, type = "error") => {
  const alertElement = document.createElement("div");
  document.body.appendChild(alertElement);
  const root = createRoot(alertElement);
  root.render(
    <Alerts
      error={error}
      type={type}
      onClose={() => {
        root.unmount();
        document.body.removeChild(alertElement);
      }}
    />
  );
};

Axios.interceptors.request.use(
  function (config) {
    showLoading();
    config.withCredentials = true;
    const language = localStorage.getItem("language") || "es-MX";
    config.headers["Accept-Language"] = language;
    const empresa = localStorage.getItem("empresa");
    config.headers["IdEmpresaUsuario"] = empresa;
    return config;
  },
  function (error) {
    hideLoading();
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function (response) {
    hideLoading();
    if (response.headers?.message !== undefined) {
      response.withCredentials = true;
      const decodeMessageHeaders = decodeMessage(response.headers.message);
      const messagetype = messageTypeHeaders(response.headers.messagetype);
      showAlert(decodeMessageHeaders, messagetype);
    }

    return response;
  },

  function (error) {
    hideLoading();
    const status = error?.response?.status;

    if (error?.response?.headers?.message !== undefined) {
      const decodeMessageHeaders = decodeMessage(
        error.response.headers.message
      );
      const messagetype = messageTypeHeaders(
        error.response.headers.messagetype
      );
      if (!isAuthenticationRequest(error.config)) {
        showAlert(decodeMessageHeaders, messagetype);
      }
      return Promise.reject(error);
    }

    if (
      (status === 401 || status === 404) &&
      !isAuthenticationRequest(error.config)
    ) {
      clearSessionData();
      showAlert(
        "Tu sesión ha expirado debido a inactividad. Por favor, vuelve a iniciar sesión para continuar. ",
        "error"
      );
      window.location.href = getLoginUrl();
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default Axios;
